import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/input/containers/input.container';

export default function GatewayRegistryBasicInfoComponent ({gateways,handleFormChange,selectedGateway,handleInnerFormChange}: any) {
  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
           <InputContainer
isDisabled
              label="UniqueId"
              name="UniqueId"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'UniqueId',

                )
              }}
              type="text"
              value={selectedGateway?.UniqueId}
          />


<InputContainer
isDisabled
              label="GatewayName"
              name="GatewayName"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'GatewayName',

                )
              }}
              type="text"
              value={selectedGateway?.GatewayName}
          />
          <InputContainer
isDisabled
              label="NpUniqueId"
              name="NpUniqueId"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'NpUniqueId',

                )
              }}
              type="text"
              value={selectedGateway?.NpUniqueId}
          />

<InputContainer
              label="Status"
              name="Status"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Status',

                )
              }}
              type="text"
              value={selectedGateway?.Status}
          />
            <InputContainer
isDisabled
               label="Included Pincodes" 
               onValueChange={( newValue: any) => {
                 const valueData: any = newValue.map((option: any) => option?.id || '')
                 handleInnerFormChange(
                  valueData,
                'IncludedPincodes'
                
                 );
               }}
               type="multiselectText"
               value={selectedGateway?.IncludedPincodes}
           />
             <InputContainer
isDisabled
               label="Excluded Pincodes" 
               onValueChange={( newValue: any) => {
                 const valueData: any = newValue.map((option: any) => option?.id || '')
                 handleInnerFormChange(
                  valueData,
                'ExcludedPincodes'
                
                 );
               }}
               type="multiselectText"
               value={selectedGateway?.ExcludedPincodes}
           />
        </div>
}
    expandedPanel="userInfo"
    headerTitle="Basic Info"
/>


<AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
           <InputContainer
isDisabled
              label="Is Enabled"
              name="IsEnabled"
              onValueChange={(event: any) => {
                handleFormChange(
                  event,
                  'Debugger.IsEnabled',
                  selectedGateway?.Debugger
                )
              }}
              type="checkbox"
              value={selectedGateway?.Debugger?.IsEnabled}
          />
          <InputContainer
isDisabled
              label="Level"
              name="Level"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Debugger.Level',
                  selectedGateway?.Debugger
                )
              }}
              type="text"
              value={selectedGateway?.Debugger?.Level}
          />
    <InputContainer
isDisabled
              label="Collection"
              name="Collection"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Debugger.Collection',
                  selectedGateway?.Debugger
                )
              }}
              type="text"
              value={selectedGateway?.Debugger?.Collection}
          />
        </div>
}
    expandedPanel="Debugger Info"
    headerTitle="Debugger Info"
/>

<AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
         <InputContainer
isDisabled
              label="Database Name"
              name="DbName"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'MongoDB.DbName',
                  selectedGateway?.MongoDB
                )
              }}
              type="text"
              value={selectedGateway?.MongoDB?.DbName}
          />
    <InputContainer
isDisabled
              label="Connection String"
              name="Connection String"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'MongoDB.ConnectionString',
                  selectedGateway?.MongoDB
                )
              }}
              type="text"
              value={selectedGateway?.MongoDB?.ConnectionString}
          />
        </div>
}
    expandedPanel="MongoDB Info"
    headerTitle="MongoDB Info"
/>
        </>
  )
}